/** @jsx jsx */

import { ReactNode } from 'react';

import { Margin, Surface, Text } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

const Styles = {
  aside: css`
    padding: 15px;
  `,
};

export type HelpBlockProps = {
  heading?: string;
  description: ReactNode;
};

const HelpBlock = (props: HelpBlockProps) => (
  <Margin margin="0px 0px 15px 0px">
    <Surface borderColor="GrayWarm4">
      <aside css={Styles.aside}>
        {props.heading && (
          <Text margin="10px 0px" tag="h4" type="Body4">
            {props.heading}
          </Text>
        )}
        <Text>{props.description}</Text>
      </aside>
    </Surface>
  </Margin>
);

export default HelpBlock;
